.tableProgress {
  display: block;
  margin-left: 50%;
  margin-right: 50%;
  margin-top: 5%;
  margin-bottom: 5%;
}